import React, { useState } from 'react'
import { useTranslate, useNotify } from 'react-admin'
import {
  Grid,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import LoadingButton from '@mui/lab/LoadingButton'


export const CreditNote = ({
  reservation,
  handleOpenConfirmationModal,
  setOpenCreditNoteModal,
  openCreditNoteModal,
  setOpenConfirmationModal,
  setLoadingCreditNote,
  loadingCreditNote,
  setCreditNoteForm,
  creditNoteForm,
  invoices,
  setInvoices
}) => {
  const translate = useTranslate()
  const handleGenerateCreditNoteAux = async () => {
    handleGenerateInvoice()
  }

  const handleGenerateInvoice = async () => {
    setLoadingCreditNote(true)
    const dataToSend = {
      reservation_id: reservation.id,
      glosa: creditNoteForm?.glosa || null,
      currency_value:
        creditNoteForm?.currency_value !== undefined && creditNoteForm?.currency_value !== ''
          ? Number(creditNoteForm?.currency_value)
          : null,
      document_branch_number: creditNoteForm?.document_branch_number || null,
    }
    const response = await reservationServices.generateCreditNote(dataToSend).catch((e) => {})
    if (response && response['B2 DDBB response']) {
      const invoicesAux = Array.isArray(response['B2 DDBB response'])
        ? response['B2 DDBB response']
        : [response['B2 DDBB response']]
      setInvoices([...invoices, ...invoicesAux])
    }
    setOpenConfirmationModal(false)
    setLoadingCreditNote(false)
  }

  const handleChangeCreditNoteData = (field, value) => {
    setCreditNoteForm((current) => ({
      ...current,
      [field]: value,
    }))
  }

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      className='sale-invoice-modal'
      open={openCreditNoteModal}
      onClose={() => {
        setCreditNoteForm({})
        setOpenCreditNoteModal(false)
      }}
    >
      <DialogTitle>{translate('ra.message.generate_credit_note_title')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <EditInputsWrap
            label={`${translate('ra.field.differentiated_change_type')} (${translate(
              'ra.message.optional'
            )})`}
            md={12}
            lg={12}
            style={{ minHeight: 0 }}
          >
            <TextField
              value={creditNoteForm?.currency_value || ''}
              onChange={(e) => handleChangeCreditNoteData('currency_value', e.target.value)}
              size='small'
              type='number'
              sx={{ width: { xs: '100%', sm: '50%' } }}
            />
          </EditInputsWrap>
          <EditInputsWrap
            label={`${translate('ra.field.text')} (${translate('ra.message.optional')})`}
            md={12}
            lg={12}
            style={{ minHeight: 0 }}
          >
            <TextField
              value={creditNoteForm?.glosa || ''}
              onChange={(e) => handleChangeCreditNoteData('glosa', e.target.value)}
              size='small'
              fullWidth
            />
          </EditInputsWrap>
          <EditInputsWrap
            label={`${translate('ra.field.document_branch_number')} (${translate('ra.message.optional')})`}
            md={12}
            lg={12}
            style={{ minHeight: 0 }}
          >
            <TextField
              value={creditNoteForm?.document_branch_number || ''}
              onChange={(e) => handleChangeCreditNoteData('document_branch_number', e.target.value)}
              size='small'
              type='number'
              fullWidth
            />
          </EditInputsWrap>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={() => {
            setCreditNoteForm({})
            setOpenCreditNoteModal(false)
          }}
        >
          {translate('ra.action.cancel')}
        </Button>
        <LoadingButton
          loading={loadingCreditNote}
          size='small'
          variant='contained'
          onClick={() => {
            handleOpenConfirmationModal('generate_credit_note_title', handleGenerateCreditNoteAux)
            setOpenCreditNoteModal(false)
            setCreditNoteForm({})
          }}
        >
          {translate('ra.action.continue')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
